import { isValid, startOfDay } from 'date-fns';
import checkIsDateMidnight from 'helpers/checkIsDateMidnight';

interface DateSelectHelpersProps {
  onDateChange: (date: Date) => void;
  date: Date | null;
  setIsOpen: (isOpen: boolean) => void;
  inputRef: React.RefObject<HTMLInputElement | null>;
  enableMidnight?: boolean;
}

export default function dateSelectHelpers({
  onDateChange,
  date,
  setIsOpen,
  inputRef,
  enableMidnight = false,
}: DateSelectHelpersProps) {
  const handleOptionChange = (
    event: React.SyntheticEvent,
    newValue: string | null,
  ) => {
    if (!newValue || !date) {
      return;
    }

    const [hours, minutes] = newValue.split(':').map(Number);

    const dateToUpdate = startOfDay(date);

    if (
      (enableMidnight && hours === 24) ||
      (enableMidnight && hours === 0 && minutes === 0)
    ) {
      dateToUpdate.setHours(23, 59, 59, 999);
      onDateChange(dateToUpdate);
      return;
    }

    dateToUpdate.setHours(hours, minutes, 0, 0);
    onDateChange(dateToUpdate);
    setIsOpen(false);
    if (inputRef.current) {
      inputRef.current.blur();
    }
  };

  const handleInputChange = (event: React.SyntheticEvent) => {
    const { value } = event.target as HTMLInputElement;
    if (!date) {
      return;
    }

    if (!value) {
      onDateChange(date);
      return;
    }

    const [hours, minutes] = value.split(':').map(Number);

    const dateToUpdate = startOfDay(date);

    if (
      (enableMidnight && hours === 24) ||
      (enableMidnight && hours === 0 && minutes === 0)
    ) {
      dateToUpdate.setHours(23, 59, 59, 999);
      onDateChange(dateToUpdate);
      return;
    }

    dateToUpdate.setHours(hours, minutes, 0, 0);
    if (!isValid(dateToUpdate)) {
      return;
    }
    onDateChange(dateToUpdate);
  };

  const convertDateToTimeString = (dateToConvert: Date) => {
    const hours = dateToConvert.getHours();
    const minutes = dateToConvert.getMinutes();
    const isDateMidnight = checkIsDateMidnight(dateToConvert);

    if (isDateMidnight) {
      return '24:00';
    }

    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
  };

  return {
    handleOptionChange,
    handleInputChange,
    convertDateToTimeString,
  };
}
